import React, { FC } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PlaySmallIcon from '../../../../assets/icons/PlaySmallIcon';
import RepeatIcon from '../../../../assets/icons/RepeatIcon';
import { calculatePathwayStatus, PATHWAY_ACTIONS } from '../../../../pages/DiscoverPage/const';
import { CustomButton } from '../../../UI/CustomButton';
import CardTestResults from '../CardTestResults/CardTestResults';
import useStyles from './styles';

interface CardPathwayActionBlockProps {
  pathwaySlug?: string | null;
  testId?: number | null;
  hash?: string | null;
  totalVideos: number;
  watchedVideos: number;
  passDate?: string | null;
  pathwayName?: string | null;
  tenantTitle?: string | null;
  tenantName?: string | null;
  wrapperClass?: string;
  cpdCredits?: string | null;
  category?: string | null;
}

const CardPathwayActionBlock: FC<CardPathwayActionBlockProps> = ({
  pathwaySlug,
  testId,
  hash,
  totalVideos,
  watchedVideos,
  passDate,
  pathwayName,
  tenantTitle,
  tenantName,
  wrapperClass,
  cpdCredits,
  category,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const status = calculatePathwayStatus(watchedVideos, totalVideos, hash, testId);

  return (
    <div className={cx(classes.wrapper, wrapperClass)}>
      {status === PATHWAY_ACTIONS.WATCH_NEW_CONTENT || status === PATHWAY_ACTIONS.PASSED_TEST ? (
        <CardTestResults
          pathwayName={pathwayName}
          passDate={passDate}
          hash={hash}
          tenantTitle={tenantTitle}
          tenantName={tenantName}
          cpdCredits={cpdCredits}
          category={category}
        />
      ) : (
        <div />
      )}

      {status === PATHWAY_ACTIONS.CONTINUE_WATCHING && (
        <Link data-testid="pathwayLink" to={`/pathway/${pathwaySlug}`}>
          <CustomButton data-testid="continueWatchingBtn" btnClass={classes.btn}>
            <PlaySmallIcon
              data-testid="play-icon"
              className={cx(classes.buttonIcon, classes.playIcon)}
            />
            {t('page.discover.continueWatching')}
          </CustomButton>
        </Link>
      )}
      {status === PATHWAY_ACTIONS.TAKE_TEST && (
        <Link data-testid="pathwayLink" to={`/pathway/${pathwaySlug}/test/${testId}`}>
          <CustomButton data-testid="takeTest">{t('page.discover.takeTest')}</CustomButton>
        </Link>
      )}
      {status === PATHWAY_ACTIONS.WATCH_NEW_CONTENT && (
        <Link data-testid="pathwayLink" to={`/pathway/${pathwaySlug}`}>
          <CustomButton data-testid="watchNewContent" btnClass={classes.btn}>
            <PlaySmallIcon
              data-testid="play-icon"
              className={cx(classes.buttonIcon, classes.playIcon)}
            />
            {t('page.discover.watchNewContent')}
          </CustomButton>
        </Link>
      )}
      {(status === PATHWAY_ACTIONS.PASSED_TEST || status === PATHWAY_ACTIONS.WATCH_AGAIN) && (
        <Link data-testid="pathwayLink" to={`/pathway/${pathwaySlug}`}>
          <CustomButton data-testid="rewatch" btnClass={classes.btn}>
            <RepeatIcon
              data-testid="repeat-icon"
              className={cx(classes.buttonIcon, classes.repeatIcon)}
            />
            {t('page.discover.rewatch')}
          </CustomButton>
        </Link>
      )}
    </div>
  );
};

export default CardPathwayActionBlock;
